import { memo } from 'react';
import useOrderProductGridContext, {
  OrderProductGridContextProvider,
} from '../../../../../contexts/OrderProductGrid.context';
import { OrderProductGridContainerProps } from '../types/orderProductGridContainer.types';
import OrderProductGridContent, {
  OrderProductGridContentProps,
} from './OrderProductGridContent/OrderProductGridContent';

const OrderProductGridContainer = (
  props: OrderProductGridContainerProps & OrderProductGridContentProps,
) => {
  return (
    <OrderProductGridContextProvider {...props}>
      <OrderProductGridContentWithGrid ExtraButton={props.ExtraButton} />
    </OrderProductGridContextProvider>
  );
};

const OrderProductGridContentWithGrid = (props: OrderProductGridContentProps) => {
  const { grid } = useOrderProductGridContext();

  if (grid.length === 0) {
    return null;
  }

  return <OrderProductGridContent {...props} />;
};

export default memo(OrderProductGridContainer);
